import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { ScrollLink } from "containers/Manual/components/content/ScrollLink";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const ISDATE = () => {
  return (
    <CardSection id="ISDATE" title="ISDATE">
      <Paragraph>
        지정된 열 내의 날짜-시간 값을 확인합니다. 날짜/시간 값이 발견되면{" "}
        <b>TRUE</b>
        값이 반환됩니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>ISDATE(ARGUMENT)</Paragraph>
        <Ul>
          <Li>
            <b>ARGUMENT</b>는 확인할 열입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>ISDATE(`COLUMN`)</Paragraph>
        <Img src="computeIsDate" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          값은 datetime 텍스트 문자열이 아닌 datetime <b>객체</b>여야 합니다.
          Excel 스프레드시트에서 가져온 데이터셋은 날짜를 datetime 객체로
          가져옵니다. 다른 모든 소스의 날짜는 <b>DATEVALUE</b> 함수를 사용하여
          datetime 객체로 변환해야 합니다.{" "}
          <ScrollLink label="DATEVALUE" targetId="DATEVALUE" isSmooth /> 섹션을
          참조하세요.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
